import type { Component, Input } from '@builder.io/sdk';

export const videoField = <T extends string = 'embed'>(name: T = 'embed' as T, showIf?: string) =>
  ({
    name,
    type: 'longText',
    showIf,
  } as const satisfies DeepReadonly<Input>);

export const videoFields = [videoField('embed')] as const satisfies DeepReadonly<Input[]>;

const videoConfig = {
  name: 'HCI Wistia Video',
  inputs: videoFields,
} satisfies Component;

export type VideoConfigProps = GenerateBuilder<typeof videoFields>;

export default videoConfig;
